export const OPTION_ALL_VALUE = ""
export const OPTION_ALL_LABEL = "Tất cả"
export const GUIDE_EMPTY = "00000000-0000-0000-0000-000000000000"

export const FAILBACK =
  "data:image/png;base64,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"

export const ACCOUNT_TYPE = {
  NHAN_VIEN: 1,
  KHACH_HANG_CA_NHAN: 2,
  DOANH_NGHIEP: 3,
  DIEM_XET_NGHIEM: 4,
  ADMIN: 9,
}

export const SYSTEM_KEY = {
  DEGREE: "DEGREE",
  LANGUAGE: "LANGUAGE",
  nhanTHANH_PHAN_GIA_DINH_SCCRD: "nhanTHANH_PHAN_GIA_DINH_SCCRD",
  RELIGION: "RELIGION",
  PACKAGE_REQUEST_STATUS: "PACKAGE_REQUEST_STATUS",
  SERVICE_TYPE: "SERVICE_TYPE",
  TYPE_SORT_PRODUCT: "TYPE_SORT_PRODUCT",
  SEX_TYPE: "SEX_TYPE",
  TYPE_WATER_PRICE: "TYPE_WATER_PRICE",
  COMMON_STATUS: "COMMON_STATUS",
  POST_STATUS: "POST_STATUS",
  BIDDING_STATUS: "BIDDING_STATUS",
  QUOTES_TYPE: "QUOTES_TYPE",
  PAY_TYPE: "PAY_TYPE",
  DIPLOMA_TYPE: "DIPLOMA_TYPE",
  SEMINAR_STATUS: "SEMINAR_STATUS",
  REQUEST_ORDER_STATUS: "REQUEST_ORDER_STATUS",
  ORDER_STATUS: "ORDER_STATUS",
  SEMINAR_TYPE: "SEMINAR_TYPE",
  SEMINAR_USER_TYPE: "SEMINAR_USER_TYPE",
  SEMINAR_USER_STATUS: "SEMINAR_USER_STATUS",
  RECRUIT_STATUS: "RECRUIT_STATUS",
  DOCUMENT_SORT_TYPE: "DOCUMENT_SORT_TYPE",
  STATUS_REQUEST: "STATUS_REQUEST",
  STATUS_KQXN: "STATUS_KQXN",
  SUBMIT_SUPPORT_REQUEST_STATUS: "SUBMIT_SUPPORT_REQUEST_STATUS",
  WORKTIME_STATUS: "WORKTIME_STATUS",
  WORKTIME_USER_STATUS: "WORKTIME_USER_STATUS",
  SALARY_STATUS: "SALARY_STATUS",
  STATUS_INFRASTRUCTURE: "STATUS_INFRASTRUCTURE",
  APPLIANCECONDITION_INFRASTRUCTURE: "APPLIANCECONDITION_INFRASTRUCTURE",
}
export const ACCOUNT_TYPE_ID = {
  1: "Doanh Nghiệp",
  2: "Phòng khám",
}

export const TOP_MODAL = "20px"
export const TYPE_LINK = {
  IMAGE_LINK: 1,
  VIDEO_LINK: 2,
  DOCUMENT_LINK: 3,
  COMPRESSION_LINK: 4,
}

export const STATUS_COLOR = [
  "#333",
  "#FF720D",
  "#FF720D",
  "#0D99FF",
  "#00AEAC",
  "#154398",
  "#154398",
]
